import { render, staticRenderFns } from "./addAdmins.vue?vue&type=template&id=35eeb149&"
import script from "./addAdmins.vue?vue&type=script&lang=js&"
export * from "./addAdmins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports